const COLORS: IColorsInterface = {
  brandWhite: "#FFFFFF",

  brandBlue50: "#72a0ff",
  brandBlue40: "#90B5FC;",
  brandBlue30: "#acc7fe",
  brandBlue20: "#c8dafe",
  brandBlue10: "#e3ebfe",

  brandGreen10: "#e6f5d6",
  brandGreen20: "#cceaaa",
  brandGreen30: "#b3e081",
  brandGreen40: "#9bd75b",
  brandGreen50: "#7FCF26",

  brandOrange10: "#fae1cd",
  brandOrange20: "#f7c39e",
  brandOrange30: "#f0a56e",
  brandOrange40: "#ee8742",
  brandOrange50: "#eb6905",

  brandGray10: "#ebebeb",
  brandGray20: "#b1b3b3",
  brandGray30: "#888b8d",
  brandGray40: "#5a5a5a",
  brandGray50: "#262626",

  // Design System colors
  dsBlueCyan: "#4D8B99",
  dsBlueDark: "#3E5B83",
  dsBluePrussian: "#4D7799",
  dsGrayDark: "#5A5A5A",
  dsGrayMedium: "#888B8D",
  dsGrayLight: "#B1B1B3",
  dsGrayLighter: "#EBEBEB",
  dsGrayLightest: "#FAFAFA",
  dsGreenMedium: "#608F55",
  dsOrangeFiery: "#EB6905",
  dsOrangeUpserve: "#EEAA00",

  error: "#e63636",

  uiDark: "#262626",
  uiExtraDark: "#1B1B1A",
  uiLight: "#fff",
  uiLink: "#72a0ff",
  uiCTA: "#72a0ff",

  bgDark: "#EBEBEB",
  bgLight: "#fafafa",

  primaryText: "#262626",
  secondaryText: "#828282",

  transparentBlack: "rgba(0,0,0,0.4)",

  // Lightspeed colors
  lspdGray50: "#F2F5F8",
  lspdGray800: "#2F3137",
  lspdBlue500: "#2E61DE",
  lspdMaple500: "#DE2E37",

  // Button colors
  lspdPrimaryGradient: "linear-gradient(180deg, #537DEC 0%, #2E61DE 100%)",
  lspdPrimaryBorder: "#1844CC",
  lspdSecondaryGradient: "linear-gradient(180deg, #FFF 0%, #F5F7FF 100%)",
  lspdSecondaryBorder: "#BCC4CA",
};

export interface IColorsInterface {
  brandWhite: string;

  brandBlue50: string;
  brandBlue40: string;
  brandBlue30: string;
  brandBlue20: string;
  brandBlue10: string;

  brandGreen10: string;
  brandGreen20: string;
  brandGreen30: string;
  brandGreen40: string;
  brandGreen50: string;

  brandOrange10: string;
  brandOrange20: string;
  brandOrange30: string;
  brandOrange40: string;
  brandOrange50: string;

  brandGray10: string;
  brandGray20: string;
  brandGray30: string;
  brandGray40: string;
  brandGray50: string;

  dsBlueCyan: string;
  dsBlueDark: string;
  dsBluePrussian: string;
  dsGrayDark: string;
  dsGrayMedium: string;
  dsGrayLight: string;
  dsGrayLighter: string;
  dsGrayLightest: string;
  dsGreenMedium: string;
  dsOrangeFiery: string;
  dsOrangeUpserve: string;

  error: string;

  uiDark: string;
  uiLight: string;
  uiLink: string;
  uiCTA: string;

  bgDark: string;
  uiExtraDark: string;
  bgLight: string;

  primaryText: string;
  secondaryText: string;

  transparentBlack: string;

  // Lightspeed colors
  lspdGray50: string;
  lspdGray800: string;
  lspdBlue500: string;
  lspdMaple500: string;
  lspdPrimaryGradient: string;
  lspdPrimaryBorder: string;
  lspdSecondaryGradient: string;
  lspdSecondaryBorder: string;
}

export default COLORS;
